/* eslint-disable react/require-default-props */
import React from 'react';
import ReactPlayer from 'react-player';
import { convertToHLSUrl } from 'components/organisms/streaming-player/utils';
import { Typography } from '@mui/material';
import { Progress } from '../../interface';

interface PlayerProps {
  isPlaying: boolean;
  playerRef?: React.Ref<ReactPlayer>;
  progressHandler: (progress: Progress) => void;
  handleIsPlaying: (isPlaying: boolean) => void;
  loop: boolean;
  url:string
  volume: number;
  playbackRate: number;
}

const VideoPlayer = ({
  isPlaying, playerRef, progressHandler, handleIsPlaying, loop, url, volume, playbackRate,
}:PlayerProps) => {
  const [videoSrc, setVideoSrc] = React.useState<string | null>(url);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    setIsLoading(true);
    const loadSource = async () => {
      if (url) {
        try {
          const convertedSrc = await convertToHLSUrl(url);
          setVideoSrc(convertedSrc);
          setIsLoading(false);
        } catch (loadError) {
          setVideoSrc(url);
          setIsLoading(false);
        }
      }
    };

    loadSource();
  }, [url]);

  if (!videoSrc || isLoading) {
    return <Typography variant="h5" sx={{ color: 'text.secondary' }}>Loading video...</Typography>;
  }

  return (
    <>
      {/* <React.StrictMode> */}

      <ReactPlayer
        url={videoSrc}
        ref={playerRef}
        width={videoSrc?.includes('youtube.com') || videoSrc?.includes('youtu.be') ? '100%' : 'auto'}
        height="100%"
        style={{ display: 'flex', maxHeight: '100%', objectFit: 'cover' }}
        playing={isPlaying}
        loop={loop}
        onProgress={progressHandler}
        progressInterval={1000}
        onEnded={() => {
          handleIsPlaying(false);
        }}
        volume={volume}
        playbackRate={playbackRate}
      />
      {/* </React.StrictMode> */}

      {/* <button type="button" onClick={() => ref?.current?.seekTo(10)}>Seek to 00:10</button> */}
    </>
  );
};

export default VideoPlayer;
